import axios from 'axios';
import {
  BILLING_ALL_RECORDS_REQUEST,
  BILLING_ALL_RECORDS_SUCCESS,
  BILLING_ALL_RECORDS_FAIL,
  BILLING_SUBMIT_REQUEST,
  BILLING_SUBMIT_SUCCESS,
  BILLING_SUBMIT_FAIL,
  BILLING_BULK_UPDATE_REQUEST,
  BILLING_BULK_UPDATE_SUCCESS,
  BILLING_BULK_UPDATE_FAIL,
  BILLING_SUPERVISOR_BANKS_REQUEST,
  BILLING_SUPERVISOR_BANKS_SUCCESS,
  BILLING_SUPERVISOR_BANKS_FAIL,
  BILLING_STATUS_UPDATE_REQUEST,
  BILLING_STATUS_UPDATE_SUCCESS,
  BILLING_STATUS_UPDATE_FAIL,
  BILLING_MASTER_LIST_REQUEST,
  BILLING_MASTER_LIST_SUCCESS,
  BILLING_MASTER_LIST_FAIL,
  BILLING_MASTER_CREATE_REQUEST,
  BILLING_MASTER_CREATE_SUCCESS,
  BILLING_MASTER_CREATE_FAIL,
  BILLING_MASTER_UPDATE_REQUEST,
  BILLING_MASTER_UPDATE_SUCCESS,
  BILLING_MASTER_UPDATE_FAIL,
  BILLING_MASTER_DELETE_REQUEST,
  BILLING_MASTER_DELETE_SUCCESS,
  BILLING_MASTER_DELETE_FAIL,
  BILLING_MASTER_BULK_DELETE_REQUEST,
  BILLING_MASTER_BULK_DELETE_SUCCESS,
  BILLING_MASTER_BULK_DELETE_FAIL,
} from '../constants/billingMasterConstants';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const authConfig = (userInfo) => ({
  headers: { Authorization: `Bearer ${userInfo.token}` },
});

const authJsonConfig = (userInfo) => ({
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${userInfo.token}`,
  },
});

export const fetchAllBillingRecords = (month = '', year = '') => async (dispatch, getState) => {
  try {
    dispatch({ type: BILLING_ALL_RECORDS_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.get(
      `${API_URL}/billing-master/all-records?month=${month}&year=${year}`,
      authConfig(userInfo),
    );
    dispatch({ type: BILLING_ALL_RECORDS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: BILLING_ALL_RECORDS_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const submitBillingRecords = (payload) => async (dispatch, getState) => {
  try {
    dispatch({ type: BILLING_SUBMIT_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.post(`${API_URL}/billing-master/submit`, payload, authJsonConfig(userInfo));
    dispatch({ type: BILLING_SUBMIT_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: BILLING_SUBMIT_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const bulkUpdateBillingRecords = (sections) => async (dispatch, getState) => {
  try {
    dispatch({ type: BILLING_BULK_UPDATE_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.put(`${API_URL}/billing-master/bulk-update`, { sections }, authJsonConfig(userInfo));
    dispatch({ type: BILLING_BULK_UPDATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: BILLING_BULK_UPDATE_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const updateBillingStatus = (id, paymentStatus) => async (dispatch, getState) => {
  try {
    dispatch({ type: BILLING_STATUS_UPDATE_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.put(
      `${API_URL}/billing-master/${id}/status`,
      { paymentStatus },
      authJsonConfig(userInfo),
    );
    dispatch({ type: BILLING_STATUS_UPDATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: BILLING_STATUS_UPDATE_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const fetchSupervisorBanks = (month = '', year = '') => async (dispatch, getState) => {
  try {
    dispatch({ type: BILLING_SUPERVISOR_BANKS_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.get(
      `${API_URL}/billing-master/supervisor-banks?month=${month}&year=${year}`,
      authConfig(userInfo),
    );
    dispatch({ type: BILLING_SUPERVISOR_BANKS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: BILLING_SUPERVISOR_BANKS_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const listBillingMasters = (search = '', page = 1, limit = 50, month = '', year = '') => async (dispatch, getState) => {
  try {
    dispatch({ type: BILLING_MASTER_LIST_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.get(
      `${API_URL}/billing-master?search=${search}&page=${page}&limit=${limit}&month=${month}&year=${year}`,
      authConfig(userInfo),
    );
    dispatch({ type: BILLING_MASTER_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: BILLING_MASTER_LIST_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const createBillingMaster = (recordData) => async (dispatch, getState) => {
  try {
    dispatch({ type: BILLING_MASTER_CREATE_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.post(`${API_URL}/billing-master`, recordData, authJsonConfig(userInfo));
    dispatch({ type: BILLING_MASTER_CREATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: BILLING_MASTER_CREATE_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const updateBillingMaster = (id, recordData) => async (dispatch, getState) => {
  try {
    dispatch({ type: BILLING_MASTER_UPDATE_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.put(`${API_URL}/billing-master/${id}`, recordData, authJsonConfig(userInfo));
    dispatch({ type: BILLING_MASTER_UPDATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: BILLING_MASTER_UPDATE_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const deleteBillingMaster = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: BILLING_MASTER_DELETE_REQUEST });
    const { userLogin: { userInfo } } = getState();
    await axios.delete(`${API_URL}/billing-master/${id}`, authConfig(userInfo));
    dispatch({ type: BILLING_MASTER_DELETE_SUCCESS });
  } catch (error) {
    dispatch({ type: BILLING_MASTER_DELETE_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const bulkDeleteBillingMaster = (ids) => async (dispatch, getState) => {
  try {
    dispatch({ type: BILLING_MASTER_BULK_DELETE_REQUEST });
    const { userLogin: { userInfo } } = getState();
    await axios.post(`${API_URL}/billing-master/bulk-delete`, { ids }, authJsonConfig(userInfo));
    dispatch({ type: BILLING_MASTER_BULK_DELETE_SUCCESS });
  } catch (error) {
    dispatch({ type: BILLING_MASTER_BULK_DELETE_FAIL, payload: error.response?.data?.message || error.message });
  }
};
